
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prior-auth-list-updates",
      function () {
        return require("private-next-pages/prior-auth-list-updates.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prior-auth-list-updates"])
      });
    }
  